module.exports = __webpack_public_path__ + "media/images/page/scene02-ccba471d69613bd625d822c5da745ff2.jpg";